import { useSelector } from 'react-redux';

import { RootState } from '@/redux/store';

export const useEnvioFlexAccess = () => {
  const { envioFlexAccess } = useSelector((state: RootState) => state.parcel);

  return {
    hasEnvioFlexAccess: envioFlexAccess.hasAccess,
    checked: envioFlexAccess.checked,
  };
};
